import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from '@mui/lab';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { isEmpty } from 'lodash-es';
import React, { FC, Fragment } from 'react';
import { ICandidate } from 'wisestep-api';

import { timeSince } from '../../helper/DateOperations/DateOperations';
import WsColors from '../../WsColors';
import Label from '../Label/Label';
import UpdatedDetailsTimeline from '../UpdatedDetailsTimeline/UpdatedDetailsTimeline';
import WsTypography, { WsTypoColors } from '../WsTypography/WsTypography';

type ColorType = {
  bgColor: string;
};

export const StyledChip = styled(Chip)(({ bgColor }: ColorType) => ({
  color: WsColors.TertiaryShades800,
  borderRadius: 4,
  fontSize: '14px',
  marginRight: 5,
  background: bgColor,
  fontWeight: 700,
}));

interface IMappingTimeline {
  candidate: ICandidate;
  taskLisiting?: JSX.Element;
  getFieldSettings: (isMapping: boolean) => any;
}

const MappingTimeline: FC<IMappingTimeline> = ({ candidate, taskLisiting, getFieldSettings }) => {
  const contactActions = candidate.contactActionsObjs ? [...candidate.contactActionsObjs] : [];

  return (
    <>
      {contactActions?.reverse()?.map((data, index: number) => (
        <Timeline key={index}>
          <TimelineItem>
            <TimelineOppositeContent
              sx={{ flex: 0 }}
              color="textSecondary"
            ></TimelineOppositeContent>
            <TimelineSeparator>
              <FiberManualRecordOutlinedIcon sx={{ color: WsColors.TheBlues500, mt: '7px' }} />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <WsTypography color={WsTypoColors.QUATERNARY}>
                {`${timeSince(String(data.createdOn)) + ' by ' + data.createdBy}`}
              </WsTypography>
            </TimelineContent>
          </TimelineItem>
          {!isEmpty(data.actions) && (
            <TimelineItem>
              <TimelineOppositeContent
                sx={{ flex: 0 }}
                color="textSecondary"
              ></TimelineOppositeContent>
              <TimelineSeparator>
                <FiberManualRecordIcon sx={{ color: WsColors.TheBlues500, mt: '7px' }} />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {data.actions &&
                  data.actions.map((action: string, index: number) => (
                    <StyledChip key={index} label={action} bgColor={WsColors.TheBlues100} />
                  ))}
              </TimelineContent>
            </TimelineItem>
          )}
          {!isEmpty(data.result.result) && (
            <TimelineItem>
              <TimelineOppositeContent
                sx={{ flex: 0 }}
                color="textSecondary"
              ></TimelineOppositeContent>
              <TimelineSeparator>
                <FiberManualRecordIcon sx={{ color: WsColors.TheBlues500, mt: '7px' }} />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {data.result.result &&
                  data.result.result.map((result: string, index: number) => (
                    <StyledChip key={index} label={result} bgColor={WsColors.Yellow300} />
                  ))}
              </TimelineContent>
            </TimelineItem>
          )}
          {!isEmpty(data.notes) && (
            <TimelineItem>
              <TimelineOppositeContent
                sx={{ flex: 0 }}
                color="textSecondary"
              ></TimelineOppositeContent>
              <TimelineSeparator>
                <FiberManualRecordIcon sx={{ color: WsColors.TheBlues500, mt: '7px' }} />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Label>Notes :</Label>
                <Label>{data.notes}</Label>
              </TimelineContent>
            </TimelineItem>
          )}
          {index === 0 && (
            <UpdatedDetailsTimeline candidate={candidate} getFieldSettings={getFieldSettings} />
          )}
          {index === 0 && <TimelineContent>{taskLisiting}</TimelineContent>}
        </Timeline>
      ))}
    </>
  );
};

export default MappingTimeline;
